module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av745-19f2a0717350a3e3dc6ed37c35dfe9ff.jpg";